/**
 * 运价库-空运运价 枚举定义
 */
import { t } from '@/i18n'

/** 运价来源 */
export const WarehouseAirSourceEnum = {
  INQUIRY: { value: 1, get label() { return t('saas.rateWarehouse.enums.source.inquiry') } },
  BIDDING: { value: 2, get label() { return t('saas.rateWarehouse.enums.source.bidding') } },
  MANUAL: { value: 3, get label() { return t('saas.rateWarehouse.enums.source.manual') } }
} as const

/** 运价状态 (status: 1-正常 2-失效 3-禁用) */
export const WarehouseAirStatusEnum = {
  NORMAL: { value: 1, get label() { return t('saas.rateWarehouse.enums.status.normal') } },
  EXPIRED: { value: 2, get label() { return t('saas.rateWarehouse.enums.status.expired') } },
  DISABLED: { value: 3, get label() { return t('saas.rateWarehouse.enums.status.disabled') } }
} as const

/** 航线等级 */
export const WarehouseAirRouteGradeEnum = {
  NORMAL: { value: 1, get label() { return t('saas.rateWarehouse.air.enums.routeGrade.normal') } },
  EXPRESS: { value: 2, get label() { return t('saas.rateWarehouse.air.enums.routeGrade.express') } }
} as const

/** 直航/中转 */
export const WarehouseAirDirectFlagEnum = {
  DIRECT: { value: 1, get label() { return t('saas.rateWarehouse.air.enums.directFlag.direct') } },
  TRANSIT: { value: 2, get label() { return t('saas.rateWarehouse.air.enums.directFlag.transit') } },
  BOTH: { value: 3, get label() { return t('saas.rateWarehouse.air.enums.directFlag.both') } }
} as const

/** 包装类型 */
export const WarehouseAirPackageTypeEnum = {
  BULK: { value: 1, get label() { return t('saas.rateWarehouse.air.enums.packageType.bulk') } },
  PALLET: { value: 2, get label() { return t('saas.rateWarehouse.air.enums.packageType.pallet') } }
} as const

/** 航程时间单位 */
export const WarehouseAirVoyageTimeUnitEnum = {
  HOUR: { value: 1, get label() { return t('saas.rateWarehouse.air.enums.voyageTimeUnit.hour') } },
  DAY: { value: 2, get label() { return t('saas.rateWarehouse.air.enums.voyageTimeUnit.day') } },
  MINUTE: { value: 3, get label() { return t('saas.rateWarehouse.air.enums.voyageTimeUnit.minute') } }
} as const

/** 将枚举对象转为 { label, value } 选项数组 */
export const toOptions = (
  enumObj: Record<string, { value: string | number | boolean; label: string }>
): { label: string; value: string | number | boolean }[] =>
  Object.values(enumObj).map(item => ({ label: item.label, value: item.value }))
